import loadable from '@loadable/component';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const ReviewGallery = loadable(() => import('containers/ReviewGallery'));

const ReviewGalleryWrapper = props => (props.isModalOpen ? <ReviewGallery {...props} /> : null);

ReviewGalleryWrapper.propTypes = {
  params: PropTypes.object.isRequired,
  product: PropTypes.shape({
    detail: PropTypes.shape({
      brandName: PropTypes.string.isRequired,
      productId: PropTypes.string.isRequired,
      productName: PropTypes.string.isRequired
    }).isRequired
  }),
  returnUrl: PropTypes.string.isRequired
};

const mapStateToProps = state => {
  const { reviews: { reviewGallery: { isModalOpen } } } = state;
  return { isModalOpen };
};

export default connect(mapStateToProps, {})(ReviewGalleryWrapper);
